<template>
	<div class="box__container">
		<div class="box__header">
			<div class="box__header__title">
				<h2>{{ 'picframe-title' | translate | capitalize }}</h2>
			</div>
		</div>

		<div class="box__body">
			<div class="box__body__subtitle">
				<p>{{ 'picframe-subtitle' | translate | capitalize }}</p>
			</div>

			<form @submit.prevent="sendPicframe">
				<div class="form__group form__group-relative">
					<div class="form__group">
						<label for="mail-voto-legal">{{ 'picframe-explication' | translate | capitalize }}</label>
						<input type="text" maxlength="256" name="email" placeholder="url do tema" v-model="user.share_url">

						<div class="has-error" v-if="errorForm(error, 'picframe_url')">
							<label class="control-label" for="inputError"><i class="fas fa-times-circle-o"></i> {{ 'picframe-error' | translate | capitalize }}</label>
						</div>
					</div>

					<div class="form__group form__group-relative">
						<label for="name">{{ 'picframe-text' | translate | capitalize }}</label>
						<textarea id="picframe-text" maxlength="250" @input="count($event, 250)" v-model="user.share_text"></textarea>
						<span id="counter-picframe-text" class="label pull-right bg-red counter"></span>
					</div>
					<div class="remove-button" v-if="this.user.share_url" @click="removeIntegration()">
						<i class="fas fa-times"></i> {{ 'remove-integration' | translate | capitalize }}
					</div>
					<div class="form__group submit__content">
						<button type="submit" :aria-busy="submitLoading ? 'true' : 'false'">
							{{ (picframeForm.id) ? 'register' : 'save' | translate | capitalize }}
						</button>
					</div>
					<div class="form__group has-success text-center">
						<label class="control-label" for="inputSuccess" v-if="picframeForm.success"><i class="fas fa-check"></i> {{ 'save-with-success' | translate | capitalize }}</label>
					</div>

				</div>
			</form>
			<div class="integration__facebook">
				<div class="integration__facebook__content">
					<a href="https://www.facebook.com/fbcameraeffects/" target="_blank">Facebook</a>
				</div>
				<div class="integration__facebook__content integration__facebook__content--share">
					<a href="https://www.facebook.com/fbcameraeffects/" target="_blank">Facebook</a>
				</div>
			</div>
			<div class="facebook-documentation">
				<a href="https://www.facebook.com/fbcameraeffects/" target="_blank">
					<i class="fab fa-facebook-square"></i>
					{{ 'facebook-documentation' | translate | capitalize }}
				</a>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'picframe',
	data() {
		return {
			session: {
				apiKey: sessionStorage.getItem('apiKey'),
				userId: sessionStorage.getItem('userId'),
			},
			picframeForm: {
				success: false,
			},
			successMsg: false,
			display: '',
			msg: 'Salvar',
			erro: false,
			submitLoading: false,
		};
	},
	computed: {
		error() {
			return this.$store.state.error;
		},
		user() {
			return this.$store.state.user;
		},
		success() {
			return this.$store.state.status;
		},
	},
	methods: {
		toggleSubmitLoading() {
			this.submitLoading = !this.submitLoading;
		},
		count(event, tam) {
			const lengthText = document.getElementById(`counter-${event.target.id}`);
			lengthText.textContent = (event.target.value.length - tam) * -1;
		},
		errorForm(obj, field) {
			let erro = false;
			if (obj) {
				if (obj[field]) {
					erro = true;
				}
			}
			return erro;
		},
		removeIntegration() {
			this.user.share_url = '';
			this.user.share_text = '';
			this.sendPicframe();
		},
		sendPicframe() {
			this.erro = false;
			const payload = {};
			payload.share_url = this.user.share_url;
			payload.share_text = this.user.share_text;

			this.toggleSubmitLoading();
			this.$store.dispatch('setPicframe', payload)
				.then(() => {
					this.toggleSubmitLoading();
					this.picframeForm.success = this.success;
					setTimeout(() => {
						this.picframeForm.success = false;
					}, 5000);
					this.$store.dispatch('loadUser', this.session);
				})
				.catch(() => {
					this.toggleSubmitLoading();
				});
		},
		collapsePainel(event) {
			$.AdminLTE.boxWidget.collapse($(event.target));
		},
	},
};
</script>




// WEBPACK FOOTER //
// _source/javascripts/modules/integrations/picframe.vue